import Cta from "@/components/cta/cta";

function SubmitStorySuccess({ image }) {

  return (
    <div className="grid-9 h-full">
      <div className="col-span-full">
        <h1 className="heading-3-small text-pretty max-md:max-w-70 md:text-center lg:max-w-118.75 lg:mx-auto xl:heading-3 text-main-light">Thank you for adding your story.</h1>
        <p className="mt-6 body-1-small text-pretty md:text-center lg:max-w-100 lg:mx-auto xl:body-2 text-main-light">You will receive a confirmation and copy of your submission over email.</p>
        <img src={image} alt="Preview" className="block w-full mt-6 lg:mt-10 lg:max-w-97.5 lg:mx-auto" />
        <Cta href="http://ancestry.com/story-scout" className="cta-big mt-6 lg:mt-10 mx-auto sm:w-fit">Keep exploring</Cta>
      </div>
    </div>
  )
}

export default SubmitStorySuccess;
